/**
 * 5.3.1.3 방화벽 ZONE 설정 Store
 *
 * @since 2017-12-12
 * @author kdydesign.kim
 */
export const state = () => ({
  // api url 목록
  apiUrl: {
    pamsZoneRuleUrl: '/api/pm/zone-rule',
    pamsZoneRuleInternalUrl: '/api/pm/zone-rule/int-net',
    pamsZoneRuleInternalListUrl: '/api/pm/int-net',
    pamsZoneRuleIPUrl: '/api/pm/zone-rule/ip',
    pamsZoneRuleDeleteUrl: '/api/pm/zone-rule/multi',
    pamsZoneApplyUrl: '/api/pm/zone-rule/apply',
    pamsZoneCancelUrl: '/api/pm/zone-rule/cancel'
  },
  getZoneSettingsList: [],
  setZoneSettingsList: {
    device_id: 1,
    pams_zone_rule_id: 3,
    pams_zone_rule_desc: '',
    pams_zone_rule_dmz_type: 1,
    pams_zone_rule_ext_type: 1,
    pams_zone_rule_int_type: 1,
    pams_zone_rule_order_set: [1, 2, 3]
  },
  internalNetworkList: [],
  externalNetworkList: [],
  dmzNetworkList: [],
  getNetworkInternalData: [],
  getNetworkIPData: [],
  errorMessage: null
})

export const mutations = {
  // 방화벽 ZONE 규칙 조회
  getZoneRuleListData (state, payload) {
    const data = payload
    for (const item of data) {
      const srcType = item.pams_zone_rule_int_type
      const dstType = item.pams_zone_rule_ext_type
      const dmzType = item.pams_zone_rule_dmz_type

      if (srcType !== 4) {
        item.pams_zone_rule_int_ip = []
      }
      if (dstType !== 4) {
        item.pams_zone_rule_out_ip = []
      }
      if (dmzType !== 4) {
        item.pams_zone_rule_dmz_ip = []
      }
      if (srcType === 1 || srcType === 2 || srcType === 3) {
        const cloneSrcItem = getAnyName(srcType, 1)
        item.pams_zone_rule_int_ip.push(cloneSrcItem[0])
      }
      if (dstType === 1 || dstType === 2 || dstType === 3) {
        const cloneDstItem = getAnyName(dstType, 2)
        item.pams_zone_rule_out_ip.push(cloneDstItem[0])
      }
      if (dmzType === 1 || dmzType === 2 || dmzType === 3) {
        const cloneDmzItem = getAnyName(dmzType, 3)
        item.pams_zone_rule_dmz_ip.push(cloneDmzItem[0])
      }
      const mngIntNetInfo = item.pams_zone_rule_policy_mng_int_net
      for (const key of mngIntNetInfo) {
        if (srcType === 5 && key.pams_zone_rule_policy_mng_int_net_type === 1) {
          item.pams_zone_rule_int_ip.push({pams_zone_rule_ip_exp: key.policy_mng_int_net_uname, pams_zone_rule_policy_mng_int_net_type: key.pams_zone_rule_policy_mng_int_net_type, pams_zone_rule_ip_type: 1})
        }
        if (dstType === 5 && key.pams_zone_rule_policy_mng_int_net_type === 2) {
          item.pams_zone_rule_out_ip.push({pams_zone_rule_ip_exp: key.policy_mng_int_net_uname, pams_zone_rule_policy_mng_int_net_type: key.pams_zone_rule_policy_mng_int_net_type, pams_zone_rule_ip_type: 2})
        }
        if (dmzType === 5 && key.pams_zone_rule_policy_mng_int_net_type === 3) {
          item.pams_zone_rule_dmz_ip.push({pams_zone_rule_ip_exp: key.policy_mng_int_net_uname, pams_zone_rule_policy_mng_int_net_type: key.pams_zone_rule_policy_mng_int_net_type, pams_zone_rule_ip_type: 3})
        }
      }
    }
    state.getZoneSettingsList = data
  },
  getZoneRuleNetworkInternalData (state, payload) {
    state.getNetworkInternalData = payload
  },
  getZoneRuleNetworkIPData (state, payload) {
    state.getNetworkIPData = payload
  },
  getInternalNetworkList (state, payload) {
    state.internalNetworkList = payload
  },
  getExternalNetworkList (state, payload) {
    state.externalNetworkList = payload
  },
  geDMZNetworkList (state, payload) {
    state.dmzNetworkList = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  // 방화벽 ZONE 규칙 조회
  async getZoneRuleListDataAction ({commit, state}) {
    let bRet = false
    try {
      const res = await this.$axios.$get(`${state.apiUrl.pamsZoneRuleUrl}/0`)
      if (res.code === 'ok') {
        commit('getZoneRuleListData', res.result)
        bRet = true
      } else {
        commit('mutationErrorMessage', res.result.msg)
        commit('getZoneRuleListData', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
      commit('getZoneRuleListData', [])
    }
    return bRet
  },
  async setZoneRuleDataAction ({commit, state}) {
    let bRet = false
    try {
      const res = await this.$axios.$put(`${state.apiUrl.pamsZoneRuleUrl}`, state.setZoneSettingsList)
      if (res.code === 'ok') {
        bRet = true
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return bRet
  },
  async setZoneRuleTypeDataAction ({commit, state}, param) {
    let bRet = false
    const apiUrl = `${state.apiUrl.pamsZoneRuleUrl}/${state.setZoneSettingsList.pams_zone_rule_id}/${param.pams_zone_rule_ui_type}/${param.pams_zone_rule_type}`
    try {
      const res = await this.$axios.$delete(apiUrl, {loading: false, loadingShow: false, successAlert: false})
      if (res.code === 'ok') {
        bRet = true
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return bRet
  },
  async getZoneRuleNetworkDataAction ({commit, state}, param) {
    let bRet = false
    let apiUrl = ''
    if (param.pams_zone_rule_type === 4) {
      apiUrl = `${state.apiUrl.pamsZoneRuleIPUrl}/${state.setZoneSettingsList.pams_zone_rule_id}/${param.pams_zone_rule_ui_type}`
    } else {
      apiUrl = `${state.apiUrl.pamsZoneRuleInternalListUrl}/0`
    }
    const strSetFunc = param.pams_zone_rule_type === 4 ? 'getZoneRuleNetworkIPData' : 'getZoneRuleNetworkInternalData'
    try {
      const res = await this.$axios.$get(apiUrl, {loading: false, loadingShow: false, successAlert: false})
      if (res.code !== 'ok') {
        commit('mutationErrorMessage', res.result.msg)
        if (param.isUpdate) {
          commit(strSetFunc, [])
        }
        return bRet
      }
      if (param.isUpdate) {
        commit(strSetFunc, res.result)
      }
      if (param.pams_zone_rule_type === 4) {
        if (param.pams_zone_rule_ui_type === 1) {
          commit('getInternalNetworkList', res.result)
        } else if (param.pams_zone_rule_ui_type === 2) {
          commit('getExternalNetworkList', res.result)
        } else if (param.pams_zone_rule_ui_type === 3) {
          commit('geDMZNetworkList', res.result)
        }
      }
      bRet = true
    } catch (error) {
      commit('mutationErrorMessage', error)
      if (param.isUpdate) {
        commit(strSetFunc, [])
      }
    }
    return bRet
  },
  async setZoneRuleNetworkDataAction ({commit, state}, param) {
    let bRet = false
    try {
      const res = await this.$axios.$post(`${state.apiUrl.pamsZoneRuleIPUrl}`, param, {loading: false, loadingShow: false, successAlert: false})
      if (res.code === 'ok') {
        bRet = true
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return bRet
  },
  async setInternalNetworkInfo ({commit, state}, {allParams}) {
    let bRet = false
    try {
      const param = {}
      param.pams_zone_rule_id = Number(state.setZoneSettingsList.pams_zone_rule_id)
      param.pams_zone_rule_policy_mng_int_net_list = allParams
      const res = await this.$axios.$post(`${state.apiUrl.pamsZoneRuleInternalUrl}`, param, {loading: false, loadingShow: false, successAlert: false})
      if (res.code === 'ok') {
        bRet = true
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return bRet
  },
  async delZoneRuleNetworkDataAction ({commit, state}, param) {
    let bRet = false
    let apiUrl = ''
    const listData = {}
    if (param.type === 4) {
      apiUrl = `${state.apiUrl.pamsZoneRuleIPUrl}`
      listData.pams_zone_rule_ip_id_list = param.data
    } else {
      apiUrl = `${state.apiUrl.pamsZoneRuleInternalUrl}`
      listData.pams_zone_rule_id = param.pams_zone_rule_id
      listData.pams_zone_rule_policy_mng_int_net_list = param.pams_zone_rule_policy_mng_int_net_list
    }
    try {
      const res = await this.$axios.$put(apiUrl, listData, {loading: false, loadingShow: false, successAlert: false})
      if (res.code === 'ok') {
        bRet = true
      } else {
        commit('mutationErrorMessage', res.result.msg)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return bRet
  },
  async applyZoneRuleAction ({commit, state}, param) {
    let bRet = false
    let data = ''
    if (param === 'apply') {
      data = await this.$axios.$put(`${state.apiUrl.pamsZoneApplyUrl}`, '', {applyMsg: true})
    } else {
      data = await this.$axios.$put(`${state.apiUrl.pamsZoneCancelUrl}`, '', {cancelMsg: true})
    }
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('mutationErrorMessage', data.result)
    }
    return bRet
  }
}
export const getters = {}
export const strict = false

function getAnyName (val, type) {
  const txtName = [
    {
      pams_zone_rule_ip_exp: 'ANY',
      pams_zone_rule_ip_type: type
    }
  ]

  if (val === 2) {
    txtName[0].pams_zone_rule_ip_exp = 'ANY(' + window.$nuxt.$t('cmn.internalNetwork') + ')'
  } else if (val === 3) {
    txtName[0].pams_zone_rule_ip_exp = 'ANY(' + window.$nuxt.$t('cmn.externalNetwork') + ')'
  }
  return txtName
}
